import React, { useEffect } from "react";
import { Form, useActionData, useNavigate } from "react-router-dom";
import { Button, Stack, styled } from "@mui/material";
import useInfoSnackbar from "../../hooks/useInfoSnackbar";

const StyledInputContainer = styled(Stack)`
  gap: 2em;
  width: 80%;
  padding: 2em 0 4em;
`;

const StyledButtonContainer = styled(Stack)`
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 4em;
`;

const EntityForm = ({
  children,
  isCreate,
}) => {
  const actionData = useActionData();
  const infoSnackbar = useInfoSnackbar();
  const navigate = useNavigate();
  const handleCancel = () => navigate("../", { replace: true });

  useEffect(() => {
    if (actionData) {
      if (actionData.code === "SUCCESS") {
        infoSnackbar.alertSuccess(actionData.message);
        navigate("../", { replace: true });
      } else {
        infoSnackbar.alertError(actionData.message);
      }
    }
  }, [actionData]);

  return (
    <Stack
      component={Form}
      method="POST"
      alignItems="center"
    >
      <StyledInputContainer>
        {children}
      </StyledInputContainer>
      <StyledButtonContainer>
        <Button
          variant="contained"
          onClick={handleCancel}
        >
          Cancel
        </Button>
        <Button
          type="submit"
          variant="contained"
        >
          {isCreate ? (
            "Create"
          ) : (
            "Save"
          )}
        </Button>
      </StyledButtonContainer>
    </Stack>
  );
};

export default EntityForm;